/**
 * index.ts
 * ----------------
 * Master reducer for the public status portal application.
 */

import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers, Reducer } from 'redux';

import { publicPortalReducer, PublicPortalState } from './publicPortal';
import { PortalState } from '../shared';
import { historyReducer } from '../shared/history';
import { liveSiteEventReducer } from '../shared/liveSiteEvent';
import { metadataReducer } from '../shared/metadata';
import { preloadReducer } from '../shared/preload';
import { statusReducer } from '../shared/status';

/**
 * Application state for public statuc portal.
 */
export interface ApplicationState extends PortalState {
    publicPortal: PublicPortalState;
}

/**
 * Master reducer for updating public portal's application state.
 * @returns Reducer for public portal's application state.
 */
export function publicAppReducer (history: History): Reducer<ApplicationState> {
    return combineReducers({
        history: historyReducer,
        liveSiteEvent: liveSiteEventReducer,
        metadata: metadataReducer,
        preload: preloadReducer,
        publicPortal: publicPortalReducer,
        router: connectRouter(history),
        status: statusReducer,
    });
}
